module.exports = __webpack_public_path__ + "img/prev-arrow.65469155.svg";